import { AutoReplySettingsForm } from '@shared/features/auto-reply-settings/types';
import { useOriginatorSettingsQuery } from '@shared/generated/graphql';
import { OriginatorSettings } from 'clerk_common/types';
import { useEffect, useState } from 'react';

type UseOriginatorSettingsOptions = {
  id: string;
};

type UseOriginatorSettingsState = {
  settings: OriginatorSettings | null;
  isLoading: boolean;
};

type UseOriginatorSettingsActions = {
  // add any actions the hook provides
  refetch: () => void;
};

type OriginatorAutoReplySettings = {
  autoReply: AutoReplySettingsForm;
};

export type UseOriginatorSettingsValue = UseOriginatorSettingsState &
  UseOriginatorSettingsActions;

const useOriginatorSettings = (
  props: UseOriginatorSettingsOptions
): UseOriginatorSettingsValue => {
  const { id } = props;
  const { data, loading, refetch } = useOriginatorSettingsQuery({
    variables: {
      id,
    },
  });
  const [originatorSettings, setOriginatorSettings] =
    useState<OriginatorAutoReplySettings | null>(null);

  useEffect(() => {
    const settingsData = data?.originatorById?.settings as OriginatorSettings;
    setOriginatorSettings(
      settingsData
        ? {
            autoReply: {
              ccRecipients: settingsData.autoReply?.ccRecipients ?? [],
              bccRecipients: settingsData.autoReply?.bccRecipients ?? [],
              draftingInstructions:
                settingsData.autoReply?.draftingInstructions ?? undefined,
              whenToRespond: settingsData.autoReply?.whenToRespond ?? [],
              draftTemplateType:
                settingsData.autoReply?.draftTemplateType ?? undefined,
              actionDefinitionId:
                settingsData.autoReply?.actionDefinitionId ?? undefined,
            },
          }
        : null
    );
  }, [data, refetch]);

  return {
    settings: originatorSettings,
    isLoading: loading,
    refetch,
  };
};

export default useOriginatorSettings;
